import { render, staticRenderFns } from "./extraUserRequestModal.vue?vue&type=template&id=61c14b2d&"
import script from "./extraUserRequestModal.vue?vue&type=script&lang=ts&"
export * from "./extraUserRequestModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports